import styled from 'styled-components';
import {
  expandHeightAndWidth,
  Flex,
  gridSizes,
  media,
  weights,
} from 'utils/style';

import Invitations from 'pages/Invitations/component';

export default styled(Invitations)`
  ${Flex.column}
  ${expandHeightAndWidth()}
  color: var(--white);
  background-color: var(--primary500);

  ${media.lessThan('extraSmall')`
    background: var(--white);
    font-size: 14px;
    color: var(--grey-gorilla');
  `};

  .main {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
    padding: 32px;

    ${media.lessThan('extraSmall')`
      padding: ${gridSizes('M')};
      justify-content: flex-start;
    `};
  }

  svg {
    margin: 0 0 64px;
    fill: var(--white);

    ${media.lessThan('extraSmall')`
      fill: var(--blue-butterfly);
      width: 94px;
      height: 26px;
      align-self: flex-start;
    `};
  }
  .info {
    margin: ${gridSizes('M')} 0 0;
    text-align: center;
    &:first-of-type {
      margin: 64px 0 0;
    }
    a {
      color: var(--white);
      font-weight: ${weights('bold')};
      text-decoration: underline;
      font-size: ${gridSizes('M')};
      &:hover {
        filter: invert(8%);
      }
    }

    ${media.lessThan('extraSmall')`
      margin: ${gridSizes('L')} 0 0;
      &:first-of-type {
        margin: 32px 0 0;
      }
      a {
        color: var(--blue-butterfly-text);
        display: block;
        text-align: center;
        font-size: 14px;
        text-decoration: none;
        font-weight: ${weights('regular')};
        &:hover {
          text-decoration: underline;
        }
      }
    `};
  }
`;
